import { HttpErrorResponse } from "@angular/common/http";
import type { ErrorEvent, EventHint } from "@sentry/angular";

/**
 * Errors the app cannot act on. WebKit drops the IndexedDB connection when the
 * app is suspended (Sentry AB-CONNECT-JAVASCRIPT-2B), and deletes the
 * database when the user clears the website data (AB-CONNECT-JAVASCRIPT-15E).
 */
export const sentryIgnoreErrors: (string | RegExp)[] = [
    /Connection to Indexed Database server lost/,
    /Database deleted by request of the user/
];

/**
 * An HTTP status 0 means the request never got a response: the device is
 * offline or the webview was suspended. These show up as many unhandled
 * HttpErrorResponse events (e.g. AB-CONNECT-JAVASCRIPT-14Z, 2F), so they are
 * dropped. Responses with a real status are still reported.
 */
export function isNetworkFailure(error: unknown): boolean {
    if (error instanceof HttpErrorResponse) {
        return error.status === 0;
    }

    return (
        typeof error === "object" &&
        error !== null &&
        (error as { name?: unknown }).name === "HttpErrorResponse" &&
        (error as { status?: unknown }).status === 0
    );
}

export function dropNetworkFailures(
    event: ErrorEvent,
    hint: EventHint
): ErrorEvent | null {
    return isNetworkFailure(hint?.originalException) ? null : event;
}
